import jsPDF from "jspdf";
import arabicToThai from "../../../../hook/arabicToThai";
import oneBell from "../../../../assets/images/license/oneBell.png";
import oneJumbo from "../../../../assets/images/license/3.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

export async function createPdfRePrintAcc1(data = []) {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  data?.forEach((person, index) => {
    if (index !== 0) pdf.addPage();

    let y = 20;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // ส่วนหัว
    pdf.text(`กรุณาส่ง`, 25, y);
    y += 10;

    pdf.text(
      `${person.NAME}  (${person.CONTNO}) (${
        person.cusType === 0 ? "ผู้กู้/จำนอง" : "คนค้ำ " + person.cusType
      })`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.address.ADDR ? person.address.ADDR : "-", 40, y);

    y += 5;
    pdf.text(
      `ต.${person.address.TUMB ? person.address.TUMB : "-"} อ.${
        person.address.AUMPDES ? person.address.AUMPDES : "-"
      } จ.${person.address.PROVDES ? person.address.PROVDES : "-"}`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.address.ZIP, 40, y);

    y += 48;
    pdf.setFontSize(14);
    pdf.text(
      `วันที่ ${dayjs(person.DOCDT).add(543, "year").format("DD MMMM YYYY")}`,
      150,
      y,
    );
    pdf.text(
      `เรื่อง   ขอให้ชำระหนี้/บอกกล่าวบังคับจำนอง เลขที่ (${person.CONTNO})`,
      20,
      y,
    );
    y += 5;
    pdf.text(
      `เรียน   ${person?.SNAM}${person?.NAME1} ${
        person?.NAME2 ? person?.NAME2 : ""
      } (ผู้กู้/จำนอง)`,
      20,
      y,
    );

    let xLeft = 30;
    let xRight = 120;
    let yGUARANTORS = y + 5;

    person?.guarantors?.forEach((g, i) => {
      let x = i % 2 === 0 ? xLeft : xRight;

      pdf.text(
        `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
          g.GARNO === 0 ? "ผู้กู้/จำนอง" : "คนค้ำ " + g.GARNO
        })`,
        x,
        yGUARANTORS,
      );

      // เมื่อครบคู่ (คนที่ 2 ในแถว) ให้ขึ้นบรรทัดใหม่
      if (i % 2 === 1) {
        yGUARANTORS += 5;
      }
    });

    // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
    y = yGUARANTORS + 15;
    // ==== CONTENT (replace เฉพาะบล็อกนี้) ====

    // กันคำสำคัญไม่ให้ถูกตัดบรรทัด
    const NBSP = "\u00A0";
    const nowrap = (s) => String(s ?? "").replace(/ /g, NBSP);
    const glue = (...parts) => parts.filter(Boolean).join(NBSP); // ต่อคำด้วย NBSP

    // พารามิเตอร์ย่อหน้า
    const LEFT = 20; // margin ซ้าย
    const WIDTH = 170; // ความกว้างเนื้อหา (mm)
    const INDENT = 10; // ย่อบรรทัดแรก (mm)
    const LINE_H = 7; // ระยะบรรทัด (mm)
    const PARA_GAP = 2.5; // ระยะเว้นระหว่างย่อหน้า (mm)

    // helper: วาดย่อหน้าแบบ "ย่อเฉพาะบรรทัดแรก"
    function drawParagraph(
      pdf,
      text,
      y,
      {
        left = LEFT,
        width = WIDTH,
        indent = INDENT,
        lineH = LINE_H,
        paraGap = PARA_GAP,
      } = {},
    ) {
      // ตัด \n ที่แฝงมา แต่ไม่ลบช่องว่างต้นประโยค
      const cleaned = String(text ?? "").replace(/\s*\n\s*/g, " ");
      const lines = pdf.splitTextToSize(cleaned, width);
      lines.forEach((line, i) => {
        const x = i === 0 ? left + indent : left; // ย่อเฉพาะบรรทัดแรก
        pdf.text(line, x, y);
        y += lineH;
      });
      return y + paraGap; // เว้นวรรคย่อหน้า
    }

    y += 5;

    // เตรียมข้อความ โดยจับคู่ "ตัวเลข + หน่วย" และ "วันที่" ด้วย NBSP
    const amountLoan = glue(currencyFormatPoint(person?.NCSHPRC), "บาท");
    const amountTotal = glue(currencyFormatPoint(person?.TOTPRC), "บาท");
    const amountInstal = glue(currencyFormatPoint(person?.TOT_UPAY), "บาท");
    const startDate = nowrap(
      dayjs(person?.FDATE).add(543, "year").format("DD MMMM YYYY"),
    );
    const lastDueDate = nowrap(
      dayjs(person?.LDATE).add(543, "year").format("DD MMMM YYYY"),
    );
    const signDate = dayjs(person?.FDATE).format("DD"); // ใช้ร่วมกับคำว่า "ของเดือน"

    const p1 =
      `ตามที่ท่าน ${nowrap(
        person?.NAME,
      )} ได้กู้ยืมเงินไปจาก บริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่) ` +
      `เป็นเงินที่จำนอง จำนวน ${amountLoan}` +
      `(${numberToThaiText(
        person?.NCSHPRC,
      )}) คิดดอกเบี้ยอัตราร้อยละ 15 ต่อปี และตกลงนำส่งดอกเบี้ยเป็นรายเดือน ` +
      `โดยกำหนดชำระงวดละ ${amountInstal} กำหนดชำระงวดแรกวันที่ ${startDate} ` +
      `และงวดถัดไปชำระทุกวันที่ ${signDate} ของเดือนรวมเป็นเงิน ตลอดสัญญาทั้งสิ้น ${amountTotal} ` +
      `และท่านได้ทำสัญญาจำนองที่ดิน เลขที่ ${person.COLOR ?? ""} ${
        person.STRNO ?? ""
      } ` +
      `ต.${person?.BAAB ?? ""} อ.${person?.MODEL ?? ""} จ.${
        person?.TYPE ?? ""
      } ` +
      `เป็นประกันหนี้กู้ยืม โดยผู้กู้ได้รับเงินกู้ครบถ้วนแล้ว`;

    const arrearAmount = currencyFormatPoint(person?.EXP_AMT);
    const arrearAmountThai = numberToThaiText(person?.EXP_AMT);

    const p2 =
      `บัดนี้ปรากฏว่าผู้กู้ผิดนัดและค้างชำระ งวดที่ ${person?.EXP_FRM} - ${person?.EXP_TO} ` +
      `ซึ่งกำหนดชำระวันที่ ${lastDueDate} รวมค้าง ${person?.EXP_PRD} งวด ` +
      `เป็นจำนวนเงิน ${glue(arrearAmount, "บาท")} (${arrearAmountThai}) ` +
      `จึงขอให้ท่านนำเงินดังกล่าวมาชำระและไถ่ถอนจำนอง ณ ที่ทำการของผู้ให้กู้และผู้รับจำนอง ` +
      `ภายใน 60 วันนับแต่วันที่ได้รับหนังสือฉบับนี้ หากพ้นกำหนดดังกล่าวแล้วยังเพิกเฉย ` +
      `ผู้ให้กู้และผู้รับจำนองจะดำเนินการตามกฎหมายต่อไป`;

    const p3 = `หากท่านได้ชำระเงินจำนวนดังกล่าวเรียบร้อยแล้ว ทางบริษัทฯ ขออภัยมา ณ โอกาสนี้`;

    // วาดย่อหน้า (ย่อเฉพาะบรรทัดแรก)
    y = drawParagraph(pdf, p1, y);
    y = drawParagraph(pdf, p2, y);
    y = drawParagraph(pdf, p3, y);

    pdf.text(`ขอแสดงความนับถือ`, 47, y + 22); // (x, y)
    let imageWidthImg = 25; // Adjust width to fit your needs
    let imageHeightImg = 15; // Adjust height to fit your needs
    pdf.addImage(
      oneJumbo,
      "PNG",
      50,
      y + 23,
      imageWidthImg - 3,
      imageHeightImg - 3,
    );

    //   pdf.text(
    //     `(${lawyerName ? lawyerName?.FNAME : "                        "}  ${
    //       lawyerName ? lawyerName?.LNAME : "                         "
    //     })`,
    //     lawyerId === 3 ? 40 : 45,
    //     y + 28
    //   ); // (x, y)
    pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 40); // (x, y)
    pdf.text("ทนายความประจำบริษัทฯ", 45, y + 44); // (x, y)
    pdf.text("ผู้รับมอบอำนาจ", 50, y + 49); // (x, y)
    pdf.text(`ขอแสดงความนับถือ`, 145, y + 22); // (x, y)
    pdf.addImage(oneBell, "PNG", 145, y + 23, imageWidthImg, imageHeightImg);

    pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 40); // (x, y)
    pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 44); // (x, y)
    pdf.text("ผู้ออกจดหมาย", 150, y + 49); // (x, y)
    pdf.setFont("THSarabunNew", "bold");
    pdf.text(
      `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.DOCDT)
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} หากมาชำระหลังจากนี้อาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
      15,
      y + 70,
    );
    pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 75); // (x, y)
  });

  // เพิ่มหน้าใหม่
  pdf.addPage();

  // ตั้งค่าฟอนต์
  pdf.setFont("THSarabunNew", "normal");
  pdf.setFontSize(16);

  // config layout
  let finalYLeft = 20;
  let finalYRight = 20;
  let leftX = 10;
  let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  let rowHeight = 30; // ความสูงต่อคน
  let count = 0;
  let columnCount = 0;

  data.forEach((person, index) => {
    const x = count % 2 === 0 ? leftX : rightX;
    let y = count % 2 === 0 ? finalYLeft : finalYRight;

    // --- ชื่อ + ประเภท ---
    const nameType = `${person.NAME} (${
      person.cusType === 0 ? "ผู้เช่าซื้อ" : "คนค้ำ " + person.cusType
    }) (${person.CONTNO})`;
    pdf.text(nameType, x, y);
    y += 6;

    // --- ที่อยู่ บรรทัด 1 ---
    if (person.address?.ADDR) {
      pdf.text(`เลขที่ ${person.address.ADDR}`, x, y);
      y += 6;
    }

    // --- ที่อยู่ บรรทัด 2 ---
    const addrLine2 = `ต.${person.address.TUMB} อ.${person.address.AUMPDES} จ.${person.address.PROVDES}`;
    pdf.text(addrLine2, x, y);
    y += 6;

    // --- ZIP ---
    pdf.text(person.address.ZIP || "", x, y);

    // --- อัปเดต Y ตามคอลัมน์ ---
    if (count % 2 === 0) {
      finalYLeft += rowHeight;
    } else {
      finalYRight += rowHeight;
      columnCount++;
    }

    count++;

    // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
    if (columnCount > 8) {
      columnCount = 0;
      console.log(" columnCount 0", columnCount);
      pdf.addPage();
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);
      finalYLeft = 20;
      finalYRight = 20;
    }
  });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
}
